export enum DonorType {
  Donors = 0,
  NonDonors = 2,
  Both = 1,
}
